import React, { useState, useEffect } from 'react';
import styled from 'styled-components';

const BackgroundInner = styled.div`
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
`;

const Wrap = styled.div`
    transform: scale(1.2);
`;

const TempBackground = styled.div`
    transition: 0.1s ease-out;
`;

// 배경 텍스트 스타일 추가
const BackgroundText = styled.div`
    position: absolute;
    top: 10%; /* 화면의 세로 중앙 */
    left: 50%; /* 화면의 가로 중앙 */
    transform: translate(-52%, -54.3%); /* 센터링을 위한 위치 조정 */

    text-align: center;
    font-weight: 700;
    font-size: 210px;
    line-height: 242px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(255, 165, 0);
`;

// 배경 텍스트 스타일 추가
const FrontText = styled.div`
    position: absolute;
    top: 10%; /* 화면의 세로 중앙 */
    left: 50%; /* 화면의 가로 중앙 */
    transform: translate(-50%, -55%); /* 센터링을 위한 위치 조정 */

    text-align: center;
    font-weight: 700;
    font-size: 210px;
    line-height: 242px;

    background: rgb(0, 92, 249);
    -webkit-background-clip: text;
    -webkit-text-stroke: 12px transparent;
    color: rgb(245, 245, 245);

    /* -webkit-text-stroke-color: ; 텍스트 테두리 색상 */
    /* -webkit-text-stroke-width: 5px; 텍스트 테두리 두께 */
`;

 const LineView = styled.div`
    position: absolute;
    margin-top: ${window.innerHeight / 1.5}px;
    left: 50%;
    transform: translateX(-50%);
    width: ${window.innerWidth / 10}px; /* 가로 길이 조정 */
    height: 5px; /* 선의 두께 */
    background-color: rgba(0, 92, 249); /* 선의 색상 */
`;

export const Discription = styled.div`
    position: absolute;
    margin-top: ${window.innerHeight / 1.45}px;
    left: 50%;
    transform: translateX(-50%);
    width: 'auto'; /* 가로 길이 조정 */

    letter-spacing: 10px;
    font-size: 40px;
    font-weight: 90;
    color: rgba(0, 92, 249);
`;

const Fkfk = styled.img`
    position: absolute;
    left: 50%;
    width: 40px;
    height: 40px;
    transform: translateX(-50%);
    margin-top: ${window.innerHeight / 1.28}px;
`;

const Introduction = () => {
    const [backMoveX, setBackMoveX] = useState(0);
    const [backMoveY, setBackMoveY] = useState(0);

    const handleMouseMove = (e) => {
        const width = window.innerWidth;
        const height = window.innerHeight;

        const moveX = (e.pageX - width / 3) / width;
        const moveY = (e.pageY - height / 3) / height;

        const newBackMoveX = -moveX * 40;
        const newBackMoveY = -moveY * 20;

        setBackMoveX(newBackMoveX);
        setBackMoveY(newBackMoveY);
    };

    useEffect(() => {
        const handleResize = () => {
            // 화면 크기가 변경될 때마다 이미지 크기를 업데이트
            const images = document.querySelectorAll('img');
            images.forEach((img) => {
                img.style.width = '100%';
                img.style.height = 'auto';
            });
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <BackgroundInner onMouseMove={handleMouseMove}>
            <Wrap>
                <TempBackground style={{ transform: `translate(${backMoveX}px, ${backMoveY}px)` }}>
                    <BackgroundText>
                        <br />
                        <br />
                        <br />
                        JAEJUNG
                        <br />
                        PORTFOLIO
                    </BackgroundText>
                </TempBackground>

                <FrontText>
                    <br />
                    <br />
                    <br />
                    JAEJUNG
                    <br />
                    PORTFOLIO
                </FrontText>
                <LineView />

                <Discription>FRONTEND DEVELOP</Discription>
                {/* <Fkfk src="images/DownArrow.gif" /> */}
            </Wrap>
        </BackgroundInner>
    );
};

export default Introduction;
